"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Handle videos
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("./_main");
_main_1.txGs1Base.content = {
    initialize: function () {
        'use strict';
        _main_1.txGs1Base.content.marginal.initialize();
        _main_1.txGs1Base.content.popupLinks.initialize();
        $.eventEmitter.on('contentUpdate', function () {
            $('.fancybox-inner').find('.tx-gs1publications-pi-detail .cart-action-success')
                .closest('#lightbox_pagetype').prop('id', 'lightbox_small');
            $.fancybox.update();
            $('.fancybox-inner').find('.tx-gs1publications-cart-view form').attr('data-async', 'true');
            _main_1.txGs1Base.forms.select.initialize();
            $.gs1_cart.initPriceCalculation();
            _main_1.txGs1Base.login.initialize();
            _main_1.txGs1Base.prg.initialize();
            // reorder elements in deviant overlay form in handheld
            // must be done seperately, as txGs1Base.panels.navigation
            // is not cleaned up yet and we have no specific methods
            _main_1.txGs1Base.respond.addFunc({
                breakpoint: ['handheld'],
                enter: function () {
                    var $loginBoxInOverlay = $('.fancybox-inner').find('form.login-register-box');
                    $loginBoxInOverlay.find('.field-wrap-permalogin').insertAfter('.field-wrap-pass', $loginBoxInOverlay);
                    $loginBoxInOverlay.find('.small').addClass('js-mnpltd-small').removeClass('small');
                },
                exit: function () {
                    var $loginBoxInOverlay = $('.fancybox-inner').find('form.login-register-box');
                    $loginBoxInOverlay.find('.field-wrap-permalogin').insertBefore('.field-wrap-pass', $loginBoxInOverlay);
                    $loginBoxInOverlay.find('.js-mnpltd-small').addClass('small');
                }
            });
        });
        _main_1.txGs1Base.complete.initialize();
        _main_1.txGs1Base.content.datepicker.initialize();
        _main_1.txGs1Base.content.lightbox.setAnchors();
        _main_1.txGs1Base.content.lightbox.attachInline();
        _main_1.txGs1Base.respond.addFunc({
            breakpoint: ['tablet_portrait', 'tablet_landscape', 'desktop'],
            enter: function () {
                _main_1.txGs1Base.content.lightbox.attach();
            },
            exit: function () {
                _main_1.txGs1Base.content.lightbox.detach();
            }
        });
    }
};
exports.default = {};
